import { graphql } from "gql";

const INTERNAL_ADMIN_ORGANIZATION_EDIT_MUTATION = graphql(`
  mutation InternalAdminOrganizationEdit(
    $id: ID!
    $input: InternalAdminEditOrganizationInput!
  ) {
    internalAdminEditOrganization(id: $id, input: $input) {
      ...InternalAdminOrganization
    }
  }
`);

export { INTERNAL_ADMIN_ORGANIZATION_EDIT_MUTATION };
